var __jsx = React.createElement;
import React, { createContext, useContext } from "react";
var FormSectionContext = /*#__PURE__*/createContext(undefined);
export var useFormSectionContext = function useFormSectionContext() {
  var context = useContext(FormSectionContext);
  if (!context) {
    throw new Error("useFormSectionContext must be used within FormSectionProvider");
  }
  return context;
};
export var FormSectionProvider = function FormSectionProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(FormSectionContext.Provider, {
    value: value
  }, children);
};